import React from "react";
import { Trans, getImage } from "app/utils";
import { Icon, PlainButton, classnames } from "@culturehq/components";
import { usePostStoryContext } from "../contexts/PostStoryContext";
import styles from "../../story-slider.module.scss";

interface TriggerButtonProps {
  imgSize: number;
}

const TriggerButton: React.FC<TriggerButtonProps> = ({ imgSize }) => {
  const {
    state: { selectedMedia } = {},
    selectedStory,
    onOpen
  } = usePostStoryContext();

  return (
    <PlainButton
      aria-labelledby="create-own-story"
      className={`${styles.card} create-own-story`}
      style={{ backgroundImage: `url(${getImage(imgSize, selectedMedia)})` }}
      onClick={onOpen}
    >
      <div id="create-own-story" style={{ display: "none" }}>
        Start your own unique story trend +100 points
      </div>
      <div className="Trending-Stories__overlay">
        <p className="Story-Tags__container">
          <span className="Story-Tags__item" key="create-your-own-story">
            <Icon icon="tags" className="category-icon" />
            <Trans>Add tags</Trans>
          </span>
        </p>
        <span className={classnames("Trending-Stories__title", styles.label)}>
          <Trans>Create your own story</Trans>
        </span>
        <div className="chq-btn">
          <Trans>Create</Trans>
          <span className="Story-Tags__points">+50</span>
        </div>
      </div>
      {selectedStory && (
        <div className="Trending-Stories__overlay--unselected" />
      )}
    </PlainButton>
  );
};

export default TriggerButton;
